import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'

import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../utils/global'
import { loadLocationWithMessage } from '../../actions/location'
import NavBarBipolar from "../../components/structure/NavBarBipolar"
import Background from '../../images/title-bipolar.jpg'
import Announcement from "../structure/announcement"
import OurTeam from "./ourteam"
import Accordion from 'react-bootstrap/Accordion'
import ReactPlayer from 'react-player'

class Bipolar extends Component {
  constructor() {
      super()
      this.state = {
        menu: false
      }
      this.toggleMenu = this.toggleMenu.bind(this)
  }

  componentDidMount() {
    this.getContent()
  }

  toggleMenu(){
    this.setState({ menu: !this.state.menu })
  }

  getContent = () => {
    var nid = 0
    var title = ''
    var get_uri2 = this.props.match.params.page
    var body = ''

    if(get_uri2 == 'about-bipolar-disorder' || get_uri2 == 'resources') {
      if(get_uri2 == 'about-bipolar-disorder') {
        nid = 17
        title = 'About Bipolar Disorder'
      } else if(get_uri2 == 'resources') {
        nid = 18
        title = 'Resources'
      }
      axios({
        method: 'post',
        url: connectNode + 'admin/content/get_content_1',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: { nid: nid }
      })
      .then((result) => {
        this.setState({
          title: title,
          body: ReactHtmlParser(result['data'].body_value),
        })
      })
    } else if(get_uri2 == 'informational-videos' || get_uri2 == 'news') {
       if(get_uri2 == 'informational-videos') {
         nid = 50
         title = 'Informational Videos'
         body = this.getInformationalVideos()[1]
       } else if(get_uri2 == 'news') {
         nid = 53
         title = 'News'
         body = this.getNews()[1]
       }
       this.setState({
         title: title,
         body: ReactHtmlParser(body),
       })
    }
  }

  getInformationalVideos = () => {
    var getData = ['', '']
    getData[0] = ''
    getData[1] = '<h4>Sara Schley’s Story</h4>'
               + '<p><a href="/bipolar/sara_schley_p1">Sara Schley\'s Interview Part 1</a></p>'
               + '<p><a href="/bipolar/sara_schley_p2">Sara Schley\'s Interview Part 2</a></p>'
               + '<hr><h4>Kimberly Allen’s Story</h4>'
               + '<p><a href="/bipolar/kimberly_allen_p1">Kimberly Allen\’s Interview Part 1</a></p>'
               + '<p><a href="/bipolar/kimberly_allen_p2">Kimberly Allen\’s Interview Part 2</a></p>'
               + '<hr><h4>Massoud Farahbakhsh’s Story</h4>'
               + '<p><a href="/bipolar/Massoud_Farahbakhsh_p1">Massoud Farahbakhsh\’s Interview Part 1</a></p>'
               + '<p><a href="/bipolar/Massoud_Farahbakhsh_p2">Massoud Farahbakhsh\’s Interview Part 2</a></p>'
               + '<hr><h4>Dr. Tatiana Cohab Khafif</h4>'
               + '<p><a href="/bipolar/DrTatianaCohabKhafif">Dr. Tatiana Cohab Khafif on Acceptance and Commitment Therapy</a></p>'
               + '<hr><h4>Dr. Amy T. Peters</h4>'
               + '<p><a href="/bipolar/DrAmyTPeters">Dr. Amy T. Peters on Neuropsychology and Bipolar Disorder</a></p><hr>'
    return getData
  }

  getNews = () => {
    var getData = ['', '']
    getData[0] = ''
    getData[1] = '<ul><li><a href="https://www.medscape.com/viewarticle/novel-opportunity-better-outcomes-bipolar-disorder-2025a1000b8y" target="_blank">https://www.medscape.com/viewarticle/novel-opportunity-better-outcomes-bipolar-disorder-2025a1000b8y</a></li>'
               + '<li><a href="https://mghpsychnews.org/childhood-abuse-influence-bipolar-disorder-symptoms/" target="_blank">Bipolar Disorder, Childhood Abuse, and Symptom Networks: A New Approach to Improving Treatment Interventions - MGH Psychiatry News</a></li>'
               + '<li><a href="https://health.usnews.com/wellness/articles/how-do-i-get-motivated-to-exercise-when-im-depressed" target="_blank">How Do I Get Motivated to Exercise When I\'m Depressed? | U.S. News</a></li>'
               + '<li><a href="https://mghpsychnews.org/prolonged-exposure-comorbid-ptsd-and-bipolar-disorder/" target="_blank">Prolonged Exposure Reduces PTSD Symptoms and Suicidality in Individuals with Bipolar Disorder - MGH Psychiatry News</a></li>'
               + '<li><a href="https://mghpsychnews.org/using-brain-organoids-for-study-of-pediatric-bipolar-disorder/" target="_blank">Cracking the Code in Pediatric Bipolar Disorder - MGH Psychiatry News</a></li>'
               + '<li><a href="https://mghpsychnews.org/brain-reboot-by-michael-henry-md/" target="_blank">Brain Reboot: New Treatments for Healing Depression by Michael Henry, MD - MGH Psychiatry News</a></li></ul>'
    return getData
  }

  render() {
    var sectionStyle = {
      backgroundColor: 'rgba(0,52,86,1.00)',
      padding: '3% 0% 3% 0%',
      color: 'rgba(255,255,255,1.0)',
      backgroundImage: `url(${Background})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    };
    const items = [
      {
        index: 1,
        header: 'What is bipolar disorder?',
        content: '<p>Bipolar disorder is a mental illness characterized by episodes of mania or hypomania alternating with episodes of major depression. There are several varieties of the disorder; the most common are bipolar 1, where mania can alternate with depression, and bipolar 2, where hypomanic episodes alternate with depressive ones.</p><p>While some people have only one episode of depression or mania in their lifetime, most have multiple episodes of depression and mania. Some have single episodes of depression or mania with periods of normal mood in between, while others may move directly from a depressive episode to a manic one and vice versa. Less common are “mixed” episodes, with both manic and depressive symptoms at the same time, and “rapid cycling,” with many episodes occurring within a short period of time.</p>'
      },
      {
        index: 2,
        header: 'How common is bipolar disorder and at what age does it usually occur?',
        content: '<p>Bipolar disorder is more common than you may think, with about 5.7 million adult Americans affected every year–roughly 2.6% of the US population age 18 and older. Bipolar disorder affects men and women equally, and it occurs in all races, ethnic groups, and social classes. The median age of onset is 25, but bipolar disorder can occur in the teens and even (though less commonly) in childhood.</p>'
      },
      {
        index: 3,
        header: 'How is bipolar disorder diagnosed?',
        content: '<p>You must have had at least one episode of either mania or hypomania to be diagnosed with bipolar disorder. A mental health provider will use the Diagnostic and Statistical Manual of Mental Disorders (DSM) to diagnose the particular type of bipolar disorder you have, based on the pattern and severity of your symptoms.</p><p>Unfortunately, bipolar disorder is often misdiagnosed because of similarities with other disorders, like major depression or borderline personality disorder. Severe episodes of bipolar mania or depression can have psychotic symptoms, including hallucinations, which can even lead to a misdiagnosis of schizophrenia. For these and other reasons, there can be a long period of time—as long as five to ten years—between the onset of symptoms and a correct diagnosis.</p>'
      },
      {
        index: 4,
        header: 'What are the symptoms of mania and hypomania?',
        content: '<p>A manic episode is a period lasting several days or more when you feels much more excited and energetic than usual. Your thoughts may be racing and you may talk a lot, you may be very restless, and you may do things that are inappropriate or risky, like spending a lot of money or being sexually promiscuous. In a manic episode it is also common to sleep far less than usual without feeling tired, have trouble concentrating, and to make grandiose or unrealistic plans. Some people experience mania as irritability or agitation so intense that they start arguments, shout at people, or hit people. In extreme cases, mania can lead to psychotic breaks with delusions and hallucinations.</p><p>Hypomanic symptoms are similar to those of mania, but are milder, usually of shorter duration, and do not include psychosis. In general, people experiencing hypomania are able to function in social situations and at work.</p>'
      },
      {
        index: 5,
        header: 'What are the symptoms of depression?',
        content: '<p>An episode of depression is more intense than ordinary sadness or “the blues,” and lasts at least two weeks, often much longer. Depression affects sleep and appetite, so you may have trouble falling or staying asleep, or sleep more than usual, and you may gain or lose weight. It can also impact your energy, so you may be very tired or feel like it takes a lot of effort to do things you used to do. During a depressive episode, it’s also common to feel bad or worthless and to lose interest in things that you used to enjoy. People with severe depression may have trouble functioning and be unable to do basic tasks.</p>'
      },
      {
        index: 6,
        header: 'How do I know if I have bipolar disorder?',
        content: '<p>A psychiatrist, psychologist, or other mental health professional can help you decide if you have bipolar disorder. If you believe that you may have bipolar disorder, consult your physician.</p>'
      },
      {
        index: 7,
        header: 'What causes bipolar disorder?',
        content: '<p>The exact cause of bipolar has not yet been identified. There are likely multiple risk factors associated with developing the disorder. Bipolar disorder is thought to be associated with chemical imbalances in certain brain cells responsible for regulating emotions and behavior. These imbalances probably come about through an interaction of genetic factors and stressful life events, medical conditions (e.g., thyroid abnormalities), or the use of certain medications. Differences in brain function can be identified in people who are depressed or manic compared with a person experiencing a normal mood state. However, it’s important to note that chemical imbalances are only part of the picture. Bipolar disorder can be managed via both psychological and pharmacological interventions.</p>'
      },
      {
        index: 8,
        header: 'What are some complications of bipolar disorder?',
        content: '<p>Going through depressed, manic, or mixed episodes can be very debilitating. Symptoms can significantly interfere with a person’s ability to take part in relationships and function well at work. Once people recover from an episode, they may find that they have has lost their jobs or strained relationships. In some cases they may have to deal with financial hardship or even homelessness. Suicide is another potential consequence of bipolar disorder, particularly among those who are untreated.</p>'
      },
      {
        index: 9,
        header: 'Can bipolar disorder be cured?',
        content: '<p>The disorder cannot be cured, but it can be treated or managed. In this way it is similar to other chronic medical conditions like diabetes or heart disease, and, as with these conditions, better treatments are being developed.</p>'
      },
      {
        index: 10,
        header: 'What should I do if someone I love has bipolar disorder?',
        content: '<p>Some of the most important things you can do are learn about bipolar disorder, encourage your loved one to get treatment, and simply be there for them. Understand that bipolar disorder is a serious illness, but that with appropriate treatment, your loved one can get better. It may be helpful to visit the websites of organizations like the National Alliance on Mental Illness (NAMI) and the Depression and Bipolar Support Alliance (DBSA) so that you and your loved one can learn more about this illness and seek appropriate support. Talking to others with bipolar disorder who have experienced the same issues and benefited from treatment can also be helpful. DBSA has support groups all over Massachusetts and the country where those with bipolar disorder and their friends with families can seek support.</p><p>For more information, please visit our <a href="/bipolar/resources">Resources</a> tab.</p>'
      },
      {
        index: 11,
        header: 'How can you help someone with bipolar disorder who does not want treatment?',
        content: '<p>Many people with acute mania do not realize that they are experiencing manic symptoms. Encourage them to see a psychiatrist or other mental health professional so that they can ask questions about mania and bipolar disorder and get support for their doubts and concerns about being diagnosed with bipolar disorder.</p>'
      },
      {
        index: 12,
        header: 'What are the treatments for bipolar disorder?',
        content: '<p>Bipolar disorder can be treated with medication and therapy, which can prevent or lessen the severity of episodes.</p><p><i>Medication</i></p><p>Multiple medications have been found to help control bipolar disorder. Some can be used to stop mania, and they may also help stop or lessen the severity of depression. These medications are also used to prevent or decrease the recurrence of episodes of mania or depression.</p><p>Some people have good responses to medications, alone or in combination. In many others, the symptoms do not completely go away. They do, however, get less intense and more manageable so that the quality of the person\'s life improves. Often, people need to take more than one medication at a time for maximal benefit.</p><p><i>Psychotherapy</i></p><p>Cognitive-behavioral therapy (CBT) or dialectical behavior therapy (DBT) can help enhance the effectiveness of medications in controlling bipolar disorder. CBT and DBT can be offered in individual or group format. CBT can help people learn to monitor and control the symptoms of bipolar disorder, to reduce obstacles to medication adherence, and to cope with stressors that may make new episodes more likely.</p><p>Cognitive therapy helps patients identify and modify patterns of thinking that accompany mood shifts. For example, if you’re depressed, you may see things in an extremely negative way; you may feel that all is doomed, that you are bad or worthless, and that nothing will ever go right. Seeing things in this distorted way can exacerbate depression. If you’re manic or hypomanic, on the other hand, you tend to see things in an overly positive way–that you’re extremely capable or powerful or that nothing can go wrong. Seeing things in this distorted way can lead to risky behaviors. In cognitive therapy, you can learn to monitor your thoughts and test them logically to counter the distortions that go with depressed and elevated moods.</p><p><i>Other treatments</i></p><p>In very severe cases, electroconvulsive therapy can help stop episodes of depression or mania. Brief hospitalization is an option if there’s a risk of hurting oneself or others. While recovering from an episode, a person may attend a day treatment program or stay in a halfway house.</p>'
      },
      /*{
        index: 13,
        header: 'How can medications help control bipolar disorder?',
        content: '<p>Multiple medications have been found to help control bipolar disorder. Some can be used to stop mania, and they may also help stop or lessen the severity of depression. These medications are also used to prevent or decrease the recurrence of episodes of mania or depression.</p><p>Some people have good responses to medications, alone or in combination. In many others, the symptoms do not completely go away. They do, however, get less intense and more manageable so that the quality of the person\'s life improves. Often, people need to take more than one medication at a time for maximal benefit.</p>'
      },
      {
        index: 14,
        header: 'How can psychotherapy help control bipolar disorder?',
        content: '<p>Cognitive-behavioral therapy  (CBT) or dialectical behavior therapy (DBT) can help enhance the effectiveness of medications in controlling bipolar disorder. CBT and DBT can be offered in individual or group format. CBT can help people learn to monitor and control the symptoms of bipolar disorder, to reduce obstacles to medication adherence, and to cope with stressors that may make new episodes more likely.</p><p>Cognitive therapy helps patients identify and modify patterns of thinking that accompany mood shifts. For example, if you’re depressed, you may see things in an extremely negative way; you may feel that all is doomed, that you are bad or worthless, and that nothing will ever go right. Seeing things in this distorted way can exacerbate depression. If you’re manic or hypomanic, on the other hand, you tend to see things in an overly positive way–that you’re extremely capable or powerful or that nothing can go wrong. Seeing things in this distorted way can lead to risky behaviors. In cognitive therapy, you can learn to monitor your thoughts and test them logically to counter the distortions that go with depressed and elevated moods.</p>'
      },*/
    ];

    return (
    <div>
      <div className="container-fluid sectionTitle" style={ sectionStyle }>
        <div className="row">
          <div className="col-md-10 offset-md-1 col-sm-12 offset-sm-0">
            <h1>{this.state.title}</h1>
          </div>
        </div>
      </div>
      <div className="container-fluid sectionBody">
        <div className="row">
          <div className="col-lg-3 offset-lg-1 col-md-10 offset-md-1 order-lg-1 order-2 sideBar">
            <NavBarBipolar loggedIn={this.state.loggedIn} />
            <Announcement />
          </div>
          <div className="col-lg-7 offset-lg-0 col-md-10 offset-md-1 col-sm-12 offset-sm-0 order-lg-2 order-1 px-3 pageBody">
          {this.props.match.params.page != 'about-bipolar-disorder' &&
          <div>
            <h2>{this.state.title}</h2>
            {this.state.body}
          </div>}
          {this.props.match.params.page == 'kimberly_allen_p1' &&
          <div>
            <h2>Kimberly Allen Part 1</h2>
            <ReactPlayer url={'/videos/Kimberly_Allen_Part1.mp4'} width='100%'
             controls = {true} className="show-only-desktop" />
          </div>}
          {this.props.match.params.page == 'kimberly_allen_p2' &&
          <div>
            <h2>Kimberly Allen Part 2</h2>
            <ReactPlayer url={'/videos/Kimberly_Allen_Part2.mp4'} width='100%'
             controls = {true} className="show-only-desktop" />
          </div>}
          {this.props.match.params.page == 'sara_schley_p1' &&
          <div>
            <h2>Sara Schley Part 1</h2>
            <ReactPlayer url={'/videos/Sara_Schley_Part1.mp4'} width='100%'
             controls = {true} className="show-only-desktop" />
          </div>}
          {this.props.match.params.page == 'sara_schley_p2' &&
          <div>
            <h2>Sara Schley Part 2</h2>
            <ReactPlayer url={'/videos/Sara_Schley_Part2.mp4'} width='100%'
             controls = {true} className="show-only-desktop" />
          </div>}
          {this.props.match.params.page == 'Massoud_Farahbakhsh_p1' &&
          <div>
            <h2>Dr.Massoud Farahbakhsh Part 1</h2>
            <ReactPlayer url={'/videos/DrMassoud_Farahbakhsh_Pt1.mp4'} width='100%'
             controls = {true} className="show-only-desktop" />
          </div>}
          {this.props.match.params.page == 'Massoud_Farahbakhsh_p2' &&
          <div>
            <h2>Dr.Massoud Farahbakhsh Part 2</h2>
            <ReactPlayer url={'/videos/DrMassoud_Farahbakhsh_Pt2.mp4'} width='100%'
             controls = {true} className="show-only-desktop" />
          </div>}
          {this.props.match.params.page == 'DrTatianaCohabKhafif' &&
          <div>
            <h2>Dr. Tatiana Cohab Khafif on Acceptance and Commitment Therapy</h2>
            <ReactPlayer url={'/videos/DrTatianaCohab_on_Acceptance_and_Commitment_Therapy.mp4'} width='100%'
             controls = {true} className="show-only-desktop" />
          </div>}
          {this.props.match.params.page == 'DrAmyTPeters' &&
          <div>
            <h2>Dr. Amy T. Peters on Neuropsychology and Bipolar Disorder</h2>
            <ReactPlayer url={'/videos/DrAmyTPeters_on_Neuropsychology_and_Bipolar Disorder.mp4'} width='100%'
             controls = {true} className="show-only-desktop" />
          </div>}
          {this.props.match.params.page == 'about-bipolar-disorder' &&
            <div>
              <h3>Our mission is to educate patients, their families, and the wider community about bipolar disorder.</h3>
              <p>Bipolar disorder is a complex illness that is often misunderstood. Depictions of bipolar disorder have tended to perpetuate misconceptions, oversimplifying the nature of the illness, focusing on mania and romanticizing it as “fun,” or portraying those with bipolar disorder as irresponsible and unwilling to get help. The reality is quite different. Bipolar disorder can manifest in many different ways; periods of mania are generally less common than periods of depression; and many people with bipolar are initially misdiagnosed, leading to delays in getting the right treatment.</p>
              <p className="responsive-iframe-container">
              <iframe src="https://www.youtube.com/embed/D1AO6Gm5o6A?si=9hNY_T-HZyZs2FMr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </p>
              <h3>Below are answers to some frequently asked questions about bipolar disorder.</h3>
              <Accordion defaultActiveKey="0">
              {items.map(each =>
                <Accordion.Item eventKey={each.index}>
                  <Accordion.Header>{each.header}</Accordion.Header>
                  <Accordion.Body>{ReactHtmlParser(each.content)}</Accordion.Body>
                </Accordion.Item>
              )}
              </Accordion>
              <div className="top_line1">References</div>
              <div><ol>
                <li>Association AP. Diagnostic and Statistical Manual of Mental Disorders, Fourth Edition (DSM-IV). Washington DC, : American Psychiatric Association Press, Inc.; 1994.</li>
                <li>“Bipolar Disorder.” National Institute of Mental Health. Web. February 2023 https://www.nimh.nih.gov/health/topics/bipolar-disorder</li>
                <li>“Bipolar Disorder Statistics.” Depression and Bipolar Support Alliance. DBSAlliance.org. Web. 18 August 2015.</li>
                <li>“Myths and Facts of Bipolar Disorder.” National Alliance on Mental Illness. Web. 5 May 2021. www.nami.org/Blogs/NAMI-Blog/May-2021</li>
                <li>“Polarity of the First Episode and Time to Diagnosis of Bipolar 1 Disorder.” Psychiatry Investig.  30 June 2009 ; 6(2): 96-101</li>
            </ol></div>
            </div>}
          </div>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Bipolar)

/**/
